import fetchUserIsLogged from '~/modules/api/rurality/v3/user/is-logged'
import { useHeaderStore } from '~/modules/api/stores/header'

export default defineNuxtRouteMiddleware(async to => {
  if (import.meta.server) return

  if (import.meta.client) {
    const headerStore = useHeaderStore()
    if (headerStore.isApp) {
      // Defer auth check to avoid blocking initial render
      const nuxtApp = useNuxtApp()
      nuxtApp.hook('page:loading:end', async () => {
        const authUserIsLogged = await fetchUserIsLogged()
        const { isAndroid, isIos } = useDevice()
        if (
          authUserIsLogged.logged === false &&
          (isAndroid || isIos) &&
          to.path !== '/signup-app'
        ) {
          if (isIos) {
            window.webkit?.messageHandlers?.logOut?.postMessage('')
            window.webkit?.messageHandlers?.goToLogin?.postMessage('')
          }
          if (isAndroid) {
            window?.ERAndroid?.logOut()
            window?.ERAndroid?.goToLogin()
          }
        }
      })
    }
  }

  return
})
